import React from 'react';
const TechnicalTemplateField = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default TechnicalTemplateField;